import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=477c57e8&scoped=true&"
import script from "./company-info.vue?vue&type=script&lang=js&"
export * from "./company-info.vue?vue&type=script&lang=js&"
import style0 from "./company-info.vue?vue&type=style&index=0&id=477c57e8&prod&lang=css&"
import style1 from "./company-info.vue?vue&type=style&index=1&id=477c57e8&prod&scoped=true&lang=css&"
import style2 from "./company-info.vue?vue&type=style&index=2&id=477c57e8&prod&lang=scss&scoped=true&"
import style3 from "./company-info.vue?vue&type=style&index=3&id=477c57e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c57e8",
  null
  
)

export default component.exports